/**
 * CC Bold Cart Handler
 * Intercepts Add to Cart form submission when Bold Options are present
 * Captures Bold options and submits them as line item properties
 * Opens sidecart instead of redirecting
 */
(function() {
  'use strict';

  const BoldCartHandler = {
    init: function() {
      this.form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form) return;

      this.waitForBoldOptions();
    },

    waitForBoldOptions: function() {
      let attempts = 0;
      const maxAttempts = 30;

      const check = () => {
        const hasBoldOptions = document.querySelector('.bold_options') &&
          (document.querySelector('.bold_option') ||
           document.querySelector('.bold_option_set') ||
           document.querySelector('[class*="bold_option"]'));
        attempts++;

        if (hasBoldOptions) {
          this.form.addEventListener('submit', (e) => this.handleSubmit(e), true);
        } else if (attempts < maxAttempts) {
          setTimeout(check, 500);
        }
      };

      check();
    },

    isSystemProperty: function(propertyName) {
      return /^s\[/.test(propertyName) ||
             /\ss\[/.test(propertyName) ||
             /^Option\ss\[/.test(propertyName) ||
             /^_/.test(propertyName) ||
             /^bold_/i.test(propertyName);
    },

    captureBoldOptions: function() {
      const options = {};

      // Radio buttons
      document.querySelectorAll('.bold_option_radio input[type="radio"]:checked').forEach(input => {
        if (input.name?.startsWith('properties[')) {
          const match = input.name.match(/properties\[(.*?)\]/);
          if (match) {
            const name = match[1].replace(/\*/g, '').trim();
            if (!this.isSystemProperty(name)) {
              options[name] = input.value;
            }
          }
        }
      });

      // Swatch helpers
      document.querySelectorAll('.bold_option_swatch input[type="hidden"][class*="_helper"]').forEach(input => {
        if (input.name?.startsWith('properties[') && input.value) {
          const match = input.name.match(/properties\[(.*?)\]/);
          if (match) {
            const name = match[1].replace(/\*/g, '').trim();
            if (!this.isSystemProperty(name)) {
              options[name] = input.value;
            }
          }
        }
      });

      // Text/number inputs
      document.querySelectorAll('.bold_option input[type="text"], .bold_option input[type="number"]').forEach(input => {
        if (input.name?.startsWith('properties[') && input.value) {
          const match = input.name.match(/properties\[(.*?)\]/);
          if (match) {
            const name = match[1].replace(/\*/g, '').trim();
            if (!this.isSystemProperty(name)) {
              options[name] = input.value;
            }
          }
        }
      });

      document.querySelectorAll('.bold_option select').forEach(select => {
        if (select.name?.startsWith('properties[') && select.value) {
          const match = select.name.match(/properties\[(.*?)\]/);
          if (match) {
            const name = match[1].replace(/\*/g, '').trim();
            if (!this.isSystemProperty(name)) {
              options[name] = select.value;
            }
          }
        }
      });

      return options;
    },

    setLoadingState: function(loading) {
      this.addToCartBtn = document.querySelector('.js-btn-add-to-cart.bold_clone') ||
                          document.querySelector('.js-btn-add-to-cart:not(.bold_hidden)') ||
                          document.querySelector('.js-btn-add-to-cart');

      if (!this.addToCartBtn) return;

      if (loading) {
        this.addToCartBtn.dataset.originalOpacity = this.addToCartBtn.style.opacity || '';
        this.addToCartBtn.dataset.originalCursor = this.addToCartBtn.style.cursor || '';
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.style.opacity = '0.6';
        this.addToCartBtn.style.cursor = 'wait';
        this.addToCartBtn.style.pointerEvents = 'none';
        this.addToCartBtn.classList.add('cc-btn-loading');

        const textSpan = this.addToCartBtn.querySelector('span.cc-inline-block') ||
                       this.addToCartBtn.querySelector('span:not(.sr-only):not([aria-hidden])') ||
                       this.addToCartBtn.querySelector('span');

        if (textSpan) {
          textSpan.dataset.originalText = textSpan.textContent;
          textSpan.textContent = 'ADDING...';
        } else {
          const innerDiv = this.addToCartBtn.querySelector('div');
          if (innerDiv) {
            innerDiv.dataset.originalHtml = innerDiv.innerHTML;
            innerDiv.innerHTML = '<span class="cc-inline-block cc-uppercase">ADDING...</span>';
          }
        }
      } else {
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.style.opacity = this.addToCartBtn.dataset.originalOpacity || '';
        this.addToCartBtn.style.cursor = this.addToCartBtn.dataset.originalCursor || '';
        this.addToCartBtn.style.pointerEvents = '';
        this.addToCartBtn.classList.remove('cc-btn-loading');

        const textSpan = this.addToCartBtn.querySelector('span.cc-inline-block') ||
                       this.addToCartBtn.querySelector('span:not(.sr-only):not([aria-hidden])');
        if (textSpan && textSpan.dataset.originalText) {
          textSpan.textContent = textSpan.dataset.originalText;
        } else {
          const innerDiv = this.addToCartBtn.querySelector('div');
          if (innerDiv && innerDiv.dataset.originalHtml) {
            innerDiv.innerHTML = innerDiv.dataset.originalHtml;
          }
        }
      }
    },

    refreshMiniCart: function() {
      return fetch('/?sections=cc-header')
        .then(response => response.json())
        .then(sections => {
          const newCartHTML = sections['cc-header'];
          if (newCartHTML) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(newCartHTML, 'text/html');

            const newContents = doc.querySelector('[data-cart-contents]');
            const currentContents = document.querySelector('[data-cart-contents]');
            if (newContents && currentContents) {
              currentContents.replaceChildren(...newContents.cloneNode(true).childNodes);
            }

            const newCount = doc.querySelector('[data-cart-item-count]');
            if (newCount) {
              document.querySelectorAll('[data-cart-item-count]').forEach(el => {
                el.textContent = newCount.textContent;
              });
            }

            const newSummary = doc.querySelector('.mini-cart-summary');
            const currentSummary = document.querySelector('.mini-cart-summary');
            if (newSummary && currentSummary) {
              currentSummary.replaceChildren(...newSummary.cloneNode(true).childNodes);
              currentSummary.classList.remove('hidden');
            }

            const emptyMessage = document.querySelector('[data-cart-empty]');
            if (emptyMessage) {
              emptyMessage.classList.add('hidden');
            }
          }
        });
    },

    openMiniCart: function() {
      const miniCartWrapper = document.querySelector('[x-data*="miniCart"]');
      if (miniCartWrapper && miniCartWrapper._x_dataStack) {
        const alpineData = miniCartWrapper._x_dataStack[0];
        if (alpineData && typeof alpineData.miniCart !== 'undefined') {
          alpineData.miniCart = true;
          return;
        }
      }

      const cartButton = document.querySelector('.btn-cart');
      const miniCartEl = document.getElementById('mini-cart');
      if (cartButton && miniCartEl && miniCartEl.classList.contains('hidden')) {
        cartButton.click();
      }
    },

    handleSubmit: function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const variantId = this.form.querySelector('input[name="id"]')?.value;
      const quantity = this.form.querySelector('input[name="quantity"]')?.value || 1;

      if (!variantId) return;

      this.setLoadingState(true);
      const loadingStartTime = Date.now();

      const boldOptions = this.captureBoldOptions();

      const payload = {
        id: variantId,
        quantity: parseInt(quantity),
        properties: boldOptions
      };

      const preorder = this.form.querySelector('input[name="properties[preorder]"]');
      if (preorder?.value) {
        payload.properties.preorder = preorder.value;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => this.refreshMiniCart())
      .then(() => {
        const elapsed = Date.now() - loadingStartTime;
        const minDelay = Math.max(0, 500 - elapsed);
        return new Promise(resolve => setTimeout(resolve, minDelay));
      })
      .then(() => {
        this.setLoadingState(false);
        this.openMiniCart();
      })
      .catch(() => {
        this.setLoadingState(false);
        alert('Failed to add to cart. Please try again.');
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => BoldCartHandler.init());
  } else {
    BoldCartHandler.init();
  }
})();
